import React, { useState } from "react";
import { CircularProgress } from "@material-ui/core";

import { useAlert } from "../components/Alert";
import Grid from "../components/Grid";
import TabView from "../components/TabView";
import LoadingModal from "../components/LoadingModal";
import CompanyDataTable from "./components/CompanyDataTable";
import AboutUsForm from "./components/AboutUsForm";
import GeneralInquiryTable from "./components/GeneralInquiryTable";
import PublicationTable from "./components/PublicationTable";
import TemplateForm from "./components/TemplateForm";
import PreviewScreen from "./components/PreviewScreen";
import CustomizeProperty from "./components/CustomizeProperty";
import SaleObjTable from "./SaleObjTable";
import FranchiseStoreTable from "./components/FranchiseStoreTable";

export default function ExclusiveWeb() {
  const Alert = useAlert();
  const [newData, setNewData] = useState({
    result: false,
    type: "query",
    edit: false,
    franchiseId: null,
    id: null,
    tabViewData: ["加盟店列表"],
    select: 0,
  });

  function changeDataListener(key, v) {}
  function changeData(key, v, rerender = false) {
    if (rerender) setNewData((prev) => ({ ...prev, [key]: v }));
    else setNewData((prev) => Object.assign(prev, { [key]: v }));
    if (typeof changeDataListener === "function") changeDataListener(key, v);
  }

  if (false) {
    return (
      <Grid container item justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else {
    return (
      <Grid>
        <LoadingModal loading={false} />
        <TabView
          scrollable
          paper
          tabs={newData.tabViewData}
          index={newData.select}
          onChange={(e) => {
            if (newData.select !== 0 && e === 0) {
              changeData("tabViewData", ["加盟店列表"]);
              changeData("franchiseId", null);
            }
            changeData("id", null);
            changeData("edit", false);
            changeData("select", e);
            changeData("type", "query");

            changeData("result", false, true);
          }}
        >
          <FranchiseStoreTable
            onChangeSelect={(item) => {
              changeData("tabViewData", [
                "加盟店列表",
                "公司資料",
                "關於我們",
                "新增物件",
                "刊登管理",
                "範本管理",
                "預覽頁面",
              ]);
              changeData("select", 1);
              changeData("franchiseId", item.id, true);
            }}
          />
          <CompanyDataTable id={newData.franchiseId} />
          <AboutUsForm id={newData.franchiseId} />
          {newData.result ? (
            <SaleObjTable id={newData.franchiseId} />
          ) : newData.type === "query" ? (
            <GeneralInquiryTable
              onResult={() => {
                changeData("result", true, true);
              }}
              onChangeType={() => {
                changeData("type", "customize", true);
              }}
            />
          ) : (
            <CustomizeProperty
              propertyId={newData.id}
              franchiseId={newData.franchiseId}
              onChangeType={() => {
                changeData("type", "query", true);
              }}
            />
          )}
          {newData.edit ? (
            <CustomizeProperty
              propertyId={newData.id}
              franchiseId={newData.franchiseId}
              onEdit={() => {
                changeData("edit", false, true);
              }}
              onChangeType={() => {
                changeData("type", "query", true);
              }}
            />
          ) : (
            <PublicationTable
              id={newData.franchiseId}
              onEdit={(item) => {
                changeData("id", item);
                changeData("edit", true, true);
              }}
            />
          )}
          <TemplateForm id={newData.franchiseId} />
          <PreviewScreen id={newData.franchiseId} />
        </TabView>
      </Grid>
    );
  }
}
